// extracted by mini-css-extract-plugin
export default {"SearchBlock":"SearchBlock_SearchBlock__cM8Ef","invalid":"SearchBlock_invalid__dPkFV","buttonGroup":"SearchBlock_buttonGroup__1eo1p","primary":"SearchBlock_primary__xhfTM"};